<div class='container' fxLayout='row' fxLayoutAlign='end center'>
    <span>{{message}}</span>
    <mat-icon>&#xe315;</mat-icon>
</div>
